import React, { useEffect, useMemo, useState } from "react";
import Datatable from "../../Components/Datatable";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from "../../../../../context/AuthContext";

export const AdminPackageList = () => {
    const { user } = useAuth();
    const { t } = useTranslation();

    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const handleEdit = (row) => {
        window.location.href = "/admin/packageedit/" + row.id;
    };



    const columns = useMemo(
        () => [
            {
                Header: t("id"),
                Footer: t("id"),
                accessor: "id",
            },
            {
                Header: t("packageName"),
                Footer: t("packageName"),
                accessor: "packageName",
            },
            {
                Header: t("packageDescription"),
                Footer: t("packageDescription"),
                accessor: "packageDetail",
            },
            {
                Header: "Kurs",
                Footer: "Kurs",
                accessor: "courseName",
            },
            {
                Header: t("packagePrice"),
                Footer: t("packagePrice"),
                accessor: "packagePrice",
            },
            {
                Header: t("studentCount"),
                Footer: t("studentCount"),
                accessor: "studentLimit",
            },
            {
                Header: t("validityDate"),
                Footer: t("validityDate"),
                accessor: "howManyDays",
            },
            {
                Header: t("isInvidual"),
                Footer: t("isInvidual"),
                accessor: "isInvidual",
            },
            {
                Header: t("isPrivate"),
                Footer: t("isPrivate"),
                accessor: "isItPrivate",
            },
            {
                Header: t("isActive"),
                Footer: t("isActive"),
                accessor: "isActive",
            },

            {
                Header: t("editCourse"),
                accessor: (originalRow) => (
                    <div className="d-flex align-items-center">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t("editPackage")}
                        </button>
                    </div>
                ),
                id: "actionEdit",
                Footer: t("editCourse"),
            },
        ],
        [t]
    );

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const headers = {
                    accept: "*/*",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "false",
                    Authorization: "Bearer " + user.token,
                };

                const packageUrl = "https://api.heryerdeingilizce.com/api/admin/Package/GetList";
                const courseUrl = "https://api.heryerdeingilizce.com/api/admin/CourseManager/GetCourses";

                const [packageRes, courseRes] = await Promise.all([
                    axios({
                        method: "GET",
                        url: packageUrl,
                        headers,
                    }),
                    axios({
                        method: "GET",
                        url: courseUrl,
                        headers,
                    }),
                ]);

                if (!(packageRes.status === 200 && packageRes.data?.success)) {
                    setMsg(packageRes.data?.message || "Paketler alınamadı.");
                    setLoading(false);
                    return;
                }

                const courseMap = {};
                if (courseRes.status === 200 && courseRes.data?.success) {
                    (courseRes.data.data || []).forEach((course) => {
                        courseMap[String(course.id)] = course.courseName;
                    });
                }

                const rows = (packageRes.data.data || []).map((item) => ({
                    id: item.id,
                    packageName: item.packageName,
                    packageDetail: item.packageDetail,
                    packagePrice: item.packagePrice,
                    studentLimit: item.studentLimit,
                    howManyDays: item.howManyDays,
                    isInvidual: item.isInvidual ? t("yes") : t("no"),
                    isActive: item.isActive ? t("active") : t("passive"),
                    isItPrivate: item.isItPrivate ? t("yes") : t("no"),
                    courseName: courseMap[String(item.sortNumber)] || `#${item.sortNumber ?? "-"}`,
                }));

                setData(rows);
            } catch (err) {
                setMsg(err?.message || "Beklenmedik bir hata oluştu.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [t, user.token]);

    return (
        <div className="container-fluid py-3">
            <div style={{ textAlign: "center" }}>
                <h1>{t("packageList")}</h1>
                <h4>{msg}</h4>

                {loading && <div>Veriler yükleniyor...</div>}

                {!loading && (
                    <div>
                        <Datatable
                            data={data}
                            columns={columns}
                            tableBaslik={t("packageList")}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminPackageList;